import { createFileRoute } from '@tanstack/react-router';
import EmailVerificationPage from '~/components/Auth/Verification/EmailVerificationPage';

export const Route = createFileRoute('/_public/email-verification')({
  component: EmailVerificationPage,
});
